import { render, staticRenderFns } from "./BuMenList.vue?vue&type=template&id=5b2ec5bc&scoped=true"
import script from "./BuMenList.vue?vue&type=script&lang=js"
export * from "./BuMenList.vue?vue&type=script&lang=js"
import style0 from "./BuMenList.vue?vue&type=style&index=0&id=5b2ec5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ec5bc",
  null
  
)

export default component.exports